import React from 'react';
import { Note, Button } from '@/components/ui';
import './ErrorDisplay.css';

interface ErrorDisplayProps {
  title?: string;
  message: string;
  onRetry?: () => void;
  retryText?: string;
  type?: 'error' | 'warning' | 'info';
  /** Kept for existing callers; the Note always shows its tone's icon. */
  showIcon?: boolean;
}

/**
 * A page-level load failure with an optional Retry. Built on the kit `Note`,
 * so it reads the same as every other inline message in the app; the title
 * leads in bold and Retry sits at the end of the bar.
 */
const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  title = 'Error',
  message,
  onRetry,
  retryText = 'Retry',
  type = 'error',
}) => (
  <div className="error-display">
    <Note
      tone={type === 'warning' ? 'warning' : type}
      action={onRetry && (
        <Button size="sm" onClick={onRetry}>
          {retryText}
        </Button>
      )}
    >
      <strong className="error-display__title">{title}</strong>
      <span className="error-display__message">{message}</span>
    </Note>
  </div>
);

export default ErrorDisplay;
